import { render, staticRenderFns } from "./Classmate.vue?vue&type=template&id=983a4738&"
import script from "./Classmate.vue?vue&type=script&lang=js&"
export * from "./Classmate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports